/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EcheancePaiementDetailDto,
  GenerateHbsRemiseResponse,
  GetEcheanceGlobalInfoResponse,
  GetFacetsResponse,
  GetGenericListCommandDto,
  GetHbsRemisesResponse,
  GetPaymentBreakdownResponse,
  GetQuittanceListResponse,
  HbsConfirmUploadResponse,
  InstallmentDetailDto,
  RemoteServiceErrorResponse,
  SearchEcheancesPaiementResponse,
  SearchPaymentSchedules400Response,
} from '../models/index';
import {
    EcheancePaiementDetailDtoFromJSON,
    EcheancePaiementDetailDtoToJSON,
    GenerateHbsRemiseResponseFromJSON,
    GenerateHbsRemiseResponseToJSON,
    GetEcheanceGlobalInfoResponseFromJSON,
    GetEcheanceGlobalInfoResponseToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetHbsRemisesResponseFromJSON,
    GetHbsRemisesResponseToJSON,
    GetPaymentBreakdownResponseFromJSON,
    GetPaymentBreakdownResponseToJSON,
    GetQuittanceListResponseFromJSON,
    GetQuittanceListResponseToJSON,
    HbsConfirmUploadResponseFromJSON,
    HbsConfirmUploadResponseToJSON,
    InstallmentDetailDtoFromJSON,
    InstallmentDetailDtoToJSON,
    RemoteServiceErrorResponseFromJSON,
    RemoteServiceErrorResponseToJSON,
    SearchEcheancesPaiementResponseFromJSON,
    SearchEcheancesPaiementResponseToJSON,
    SearchPaymentSchedules400ResponseFromJSON,
    SearchPaymentSchedules400ResponseToJSON,
} from '../models/index';

export interface ConfirmHbsUploadRequest {
    id: string;
}

export interface DownloadHbsRemiseRequest {
    id: string;
}

export interface GetAdminQuittanceListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminQuittancesRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetPaymentBreakdownRequest {
    paymentScheduleId: string;
}

export interface GetPaymentScheduleByIdRequest {
    paymentScheduleId: string;
}

export interface GetPaymentScheduleGlobalInfoRequest {
    paymentScheduleId: string;
}

export interface GetQuittanceInstallmentsRequest {
    id: string;
}

export interface SearchPaymentSchedulesRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

/**
 * 
 */
export class PaymentScheduleApi extends runtime.BaseAPI {

    /**
     * À appeler après le dépôt réel du fichier sur le portail HBS, pour la remise identifiée par son id (Guid). Renvoie un OperationResponse ; la notification de succès (« Upload confirmé pour la remise du JJ/MM/AAAA. ») est affichée automatiquement côté front. Échec : isSuccess = false + « Remise HBS introuvable. » 
     * Confirmer l\'upload d\'une remise HBS
     */
    async confirmHbsUploadRaw(requestParameters: ConfirmHbsUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HbsConfirmUploadResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling confirmHbsUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prelevements/hbs/remises/{id}/confirmer-upload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HbsConfirmUploadResponseFromJSON(jsonValue));
    }

    /**
     * À appeler après le dépôt réel du fichier sur le portail HBS, pour la remise identifiée par son id (Guid). Renvoie un OperationResponse ; la notification de succès (« Upload confirmé pour la remise du JJ/MM/AAAA. ») est affichée automatiquement côté front. Échec : isSuccess = false + « Remise HBS introuvable. » 
     * Confirmer l\'upload d\'une remise HBS
     */
    async confirmHbsUpload(requestParameters: ConfirmHbsUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HbsConfirmUploadResponse> {
        const response = await this.confirmHbsUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Télécharge le fichier CSV de la remise identifiée par son id (Guid). Sans effet de bord — re-téléchargeable à volonté. Sert juste après la génération et pour tout re-téléchargement depuis le tableau des remises. 
     * Télécharger le CSV d\'une remise HBS
     */
    async downloadHbsRemiseRaw(requestParameters: DownloadHbsRemiseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling downloadHbsRemise().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prelevements/hbs/remises/{id}/csv`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Télécharge le fichier CSV de la remise identifiée par son id (Guid). Sans effet de bord — re-téléchargeable à volonté. Sert juste après la génération et pour tout re-téléchargement depuis le tableau des remises. 
     * Télécharger le CSV d\'une remise HBS
     */
    async downloadHbsRemise(requestParameters: DownloadHbsRemiseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadHbsRemiseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Génère la remise des affaires nouvelles animaux (PR_ANI) et renvoie un JSON (pattern ABP RemoteStreamContent : le POST est une action, le GET télécharge le fichier). Effet de bord : chaque contrat inclus est marqué « transmis » au moment de l\'appel ; une remise est toujours tracée, même à 0 contrat. Si contractsCount > 0, enchaîner sur GET /remises/{generationId}/csv pour télécharger le fichier. Le job back génère aussi automatiquement le 5 du mois à 4h — ce POST reste pour le manuel / rattrapage. 
     * Générer la remise CSV HBS (affaires nouvelles)
     */
    async generateHbsRemiseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateHbsRemiseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prelevements/hbs/csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateHbsRemiseResponseFromJSON(jsonValue));
    }

    /**
     * Génère la remise des affaires nouvelles animaux (PR_ANI) et renvoie un JSON (pattern ABP RemoteStreamContent : le POST est une action, le GET télécharge le fichier). Effet de bord : chaque contrat inclus est marqué « transmis » au moment de l\'appel ; une remise est toujours tracée, même à 0 contrat. Si contractsCount > 0, enchaîner sur GET /remises/{generationId}/csv pour télécharger le fichier. Le job back génère aussi automatiquement le 5 du mois à 4h — ce POST reste pour le manuel / rattrapage. 
     * Générer la remise CSV HBS (affaires nouvelles)
     */
    async generateHbsRemise(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateHbsRemiseResponse> {
        const response = await this.generateHbsRemiseRaw(initOverrides);
        return await response.value();
    }

    /**
     * Facettes : statuses (statuts d\'échéance), withdrawalModes (E-mandat / CSV HBS / Externe), products, plateformes. Les compteurs tiennent compte du filtre isTest transmis dans le body. Permission BackOffice.AdminPrelevements.Read. 
     * Facettes de la liste des prélèvements (BO admin)
     */
    async getAdminQuittanceListFacetsRaw(requestParameters: GetAdminQuittanceListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminQuittanceListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes : statuses (statuts d\'échéance), withdrawalModes (E-mandat / CSV HBS / Externe), products, plateformes. Les compteurs tiennent compte du filtre isTest transmis dans le body. Permission BackOffice.AdminPrelevements.Read. 
     * Facettes de la liste des prélèvements (BO admin)
     */
    async getAdminQuittanceListFacets(requestParameters: GetAdminQuittanceListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminQuittanceListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée : 1 ligne = 1 quittance (échéancier d\'un contrat), avec échéance mise en avant, progression et état agrégé. Permission BackOffice.AdminPrelevements.Read. Tri par défaut : envoyer sortBy = null -> tri intelligent (erreurs d\'abord, puis prochaine échéance croissante, soldées en dernier). filters : statuses, withdrawalModes, productIds, plateformeIds, period (dates d\'échéance), isTest (tri-état : absent = tout, false = exclure les tests, true = uniquement les tests). searchString : identifiant contrat, nom/prénom souscripteur, n° quittance, RUM. 
     * Liste des prélèvements groupée par quittance (BO admin)
     */
    async getAdminQuittancesRaw(requestParameters: GetAdminQuittancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuittanceListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminQuittances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuittanceListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée : 1 ligne = 1 quittance (échéancier d\'un contrat), avec échéance mise en avant, progression et état agrégé. Permission BackOffice.AdminPrelevements.Read. Tri par défaut : envoyer sortBy = null -> tri intelligent (erreurs d\'abord, puis prochaine échéance croissante, soldées en dernier). filters : statuses, withdrawalModes, productIds, plateformeIds, period (dates d\'échéance), isTest (tri-état : absent = tout, false = exclure les tests, true = uniquement les tests). searchString : identifiant contrat, nom/prénom souscripteur, n° quittance, RUM. 
     * Liste des prélèvements groupée par quittance (BO admin)
     */
    async getAdminQuittances(requestParameters: GetAdminQuittancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuittanceListResponse> {
        const response = await this.getAdminQuittancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Renvoie la liste des remises HBS (triées de la plus récente à la plus ancienne) et le contexte d\'environnement pour le bandeau garde-fou. Appelé au montage de l\'écran et re-fetché après une génération ou une confirmation d\'upload. Nécessite la permission BackOffice.PrelevementsHbs.Read (403 sinon). 
     * Lister les remises HBS générées
     */
    async getHbsRemisesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHbsRemisesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prelevements/hbs/remises`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHbsRemisesResponseFromJSON(jsonValue));
    }

    /**
     * Renvoie la liste des remises HBS (triées de la plus récente à la plus ancienne) et le contexte d\'environnement pour le bandeau garde-fou. Appelé au montage de l\'écran et re-fetché après une génération ou une confirmation d\'upload. Nécessite la permission BackOffice.PrelevementsHbs.Read (403 sinon). 
     * Lister les remises HBS générées
     */
    async getHbsRemises(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHbsRemisesResponse> {
        const response = await this.getHbsRemisesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the breakdown (ventilation) of a payment schedule showing how the amount is distributed among beneficiaries
     * Get payment breakdown
     */
    async getPaymentBreakdownRaw(requestParameters: GetPaymentBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentBreakdownResponse>> {
        if (requestParameters['paymentScheduleId'] == null) {
            throw new runtime.RequiredError(
                'paymentScheduleId',
                'Required parameter "paymentScheduleId" was null or undefined when calling getPaymentBreakdown().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/{paymentScheduleId}/ventilation`.replace(`{${"paymentScheduleId"}}`, encodeURIComponent(String(requestParameters['paymentScheduleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentBreakdownResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the breakdown (ventilation) of a payment schedule showing how the amount is distributed among beneficiaries
     * Get payment breakdown
     */
    async getPaymentBreakdown(requestParameters: GetPaymentBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentBreakdownResponse> {
        const response = await this.getPaymentBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single payment schedule (échéance de paiement) by its unique identifier
     * Get payment schedule by ID
     */
    async getPaymentScheduleByIdRaw(requestParameters: GetPaymentScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EcheancePaiementDetailDto>> {
        if (requestParameters['paymentScheduleId'] == null) {
            throw new runtime.RequiredError(
                'paymentScheduleId',
                'Required parameter "paymentScheduleId" was null or undefined when calling getPaymentScheduleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/{paymentScheduleId}`.replace(`{${"paymentScheduleId"}}`, encodeURIComponent(String(requestParameters['paymentScheduleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EcheancePaiementDetailDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve a single payment schedule (échéance de paiement) by its unique identifier
     * Get payment schedule by ID
     */
    async getPaymentScheduleById(requestParameters: GetPaymentScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EcheancePaiementDetailDto> {
        const response = await this.getPaymentScheduleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve global information (header + contract payment history) for a payment schedule
     * Get payment schedule global info
     */
    async getPaymentScheduleGlobalInfoRaw(requestParameters: GetPaymentScheduleGlobalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEcheanceGlobalInfoResponse>> {
        if (requestParameters['paymentScheduleId'] == null) {
            throw new runtime.RequiredError(
                'paymentScheduleId',
                'Required parameter "paymentScheduleId" was null or undefined when calling getPaymentScheduleGlobalInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/{paymentScheduleId}/global-info`.replace(`{${"paymentScheduleId"}}`, encodeURIComponent(String(requestParameters['paymentScheduleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEcheanceGlobalInfoResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve global information (header + contract payment history) for a payment schedule
     * Get payment schedule global info
     */
    async getPaymentScheduleGlobalInfo(requestParameters: GetPaymentScheduleGlobalInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEcheanceGlobalInfoResponse> {
        const response = await this.getPaymentScheduleGlobalInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tableau ordonné (number croissant) des échéances de la quittance. Chargé à la demande (expansion de ligne), pas au chargement de la liste. Permission BackOffice.AdminPrelevements.Read. 
     * Détail de l\'échéancier d\'une quittance
     */
    async getQuittanceInstallmentsRaw(requestParameters: GetQuittanceInstallmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstallmentDetailDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getQuittanceInstallments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/quittances/{id}/echeances`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstallmentDetailDtoFromJSON));
    }

    /**
     * Tableau ordonné (number croissant) des échéances de la quittance. Chargé à la demande (expansion de ligne), pas au chargement de la liste. Permission BackOffice.AdminPrelevements.Read. 
     * Détail de l\'échéancier d\'une quittance
     */
    async getQuittanceInstallments(requestParameters: GetQuittanceInstallmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstallmentDetailDto>> {
        const response = await this.getQuittanceInstallmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search and retrieve a paginated list of payment schedules with optional filtering
     * Search payment schedules
     */
    async searchPaymentSchedulesRaw(requestParameters: SearchPaymentSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchEcheancesPaiementResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling searchPaymentSchedules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/echeances-paiement/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchEcheancesPaiementResponseFromJSON(jsonValue));
    }

    /**
     * Search and retrieve a paginated list of payment schedules with optional filtering
     * Search payment schedules
     */
    async searchPaymentSchedules(requestParameters: SearchPaymentSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchEcheancesPaiementResponse> {
        const response = await this.searchPaymentSchedulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
